// extracted by mini-css-extract-plugin
export default {"container":"NotFound__container--a7MZo","heading":"NotFound__heading--xEqNC","content":"NotFound__content--gyToz"};